import React from "react";
import { SemanticSIZES, Icon } from "semantic-ui-react";
import { BalloonDiv } from "../../components/BalloonDiv";

const getSizeClasses = (size: SemanticSIZES): string => {
  const sizeMap: Record<SemanticSIZES, string> = {
    mini: "tw-text-[0.64285714rem] tw-px-1 tw-py-0.5 tw-leading-tight",
    tiny: "tw-text-[0.71428571rem] tw-px-1.5 tw-py-0.5 tw-leading-tight",
    small: "tw-text-[0.78571429rem] tw-px-2 tw-py-1 tw-leading-snug",
    medium: "tw-text-[1rem] tw-px-2.5 tw-py-1 tw-leading-normal",
    large: "tw-text-[1rem] tw-px-3 tw-py-1.5 tw-leading-normal",
    big: "tw-text-[1.28571429rem] tw-px-3.5 tw-py-2 tw-leading-relaxed",
    huge: "tw-text-[1.42857143rem] tw-px-4 tw-py-2.5 tw-leading-relaxed",
    massive: "tw-text-[1.71428571rem] tw-px-5 tw-py-3 tw-leading-loose",
  };

  return sizeMap[size] || sizeMap.medium;
};

type LabelProps = {
  as?: string; // unused, for existing code compatibility
  onClick?: () => Promise<void> | void;
  onRemove?: () => Promise<void> | void;
  size: SemanticSIZES;
};

type Props = {
  content: string;
  colorPrimary?: boolean;
  disabled?: boolean;
  description: string;
  labelProps: LabelProps;
  isSelected?: boolean;
  pos?: string;
  skipPredefinedClasses?: boolean;
  classNames?: string;
};

export const TemplateLabelChip: React.FC<Props> = ({
  content,
  colorPrimary,
  disabled,
  description,
  labelProps,
  isSelected,
  pos,
  skipPredefinedClasses,
  classNames,
}) => {
  const blueVariant = isSelected || colorPrimary || false;
  const sizeClasses = getSizeClasses(labelProps.size);
  let classes = `${blueVariant ? "tw-bg-primary tw-text-white" : ""} ${
    disabled ? "tw-opacity-50 tw-cursor-not-allowed" : ""
  } ${sizeClasses}`;
  if (!skipPredefinedClasses) {
    classes += " tw-leading-none";
  }
  if (labelProps.onClick) {
    classes += " tw-cursor-pointer";
  }
  if (classNames) {
    classes += ` ${classNames}`;
  }

  if (description) {
    return (
      <BalloonDiv
        className=""
        value={description}
        pos={pos ?? "up-right"}
        as="span"
      >
        <span
          className={`
            tw-mr-0.5
            tw-bg-[#E8E8E8]
            tw-text-black
            tw-text-opacity-60
            tw-rounded
            tw-inline-block
            !tw-font-medium
            ${blueVariant && "tw-border-primary tw-bg-primary tw-text-white"}
            ${classes} 
        `}
          data-testid="row-label"
          onClick={labelProps.onClick}
        >
          {content} {isSelected && <Icon name="checkmark" size="small" />}
        </span>
      </BalloonDiv>
    );
  }
  return (
    <>
      <span
        className={`
            tw-mr-0.5
            tw-bg-[#E8E8E8]
            tw-text-black
            tw-text-opacity-60
            tw-rounded
            tw-inline-block
            !tw-font-medium
            ${blueVariant && "tw-border-primary tw-bg-primary tw-text-white"}
            ${classes} 
        `}
        data-testid="row-label"
        onClick={labelProps.onClick}
      >
        {content} {isSelected && <Icon name="checkmark" size="small" />}
      </span>
    </>
  );
};
